import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLiveEvents } from '../lib/sse';
import { Sidebar } from './Sidebar';
import { TestBanner } from './TestBanner';

export function AppShell() {
  const { user } = useAuth();
  // SSE: /api/events → message.new / conversation.updated / test_mode.changed ...
  const liveStatus = useLiveEvents(Boolean(user));

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        İçeriğe atla
      </a>
      <Sidebar liveStatus={liveStatus} />
      <div className="app-main">
        <TestBanner />
        <div id="main-content" className="app-content" tabIndex={-1}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
